import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';

type commonReqType = {
  userId: string;
};

// InfoBox (titleObj) 정보요청
export const fetchExploreInfoBox = createAsyncThunk('fetchExploreInfoBox', async (params: commonReqType) => {
  const { data, status } = await axiosDummyInstance.get('/api/keyword/exploreTitleObj.json', { params });
  if (status === 200) {
    return data;
  }
});

// gridBoxData 정보요청
export const fetchExploreGridBox = createAsyncThunk('fetchExploreGridBox', async (params: commonReqType) => {
  const { data, status } = await axiosDummyInstance.get('/api/keyword/exploreGridData.json', { params });
  if (status === 200) {
    return data;
  }
});
